import { VipProps } from './index';
import { TextEditorProps } from '../text-editor/TextEditor';
import './../text-editor/style.scss';
import { ReduxSelectorProps } from '../../services/constants';
import {
  getBorderProps,
  getMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';

export const Vip = ({
  currentDeviceType,
  ...vipData
}: VipProps &
  TextEditorProps &
  ReduxSelectorProps & {
    currentDeviceType: 'desktop' | 'tablet' | 'mobile';
  }) => {
  const marginStyles = getMarginStyles(vipData?.margin, currentDeviceType);

  return (
    <>
      {/* for future use */}
      {/* {!!(
        searchParams.get('cart') === 'PHOENIX_CART_PREVIEW' ||
        cartData?.HasSubscription ||
        getIsViewIsEdit()
      ) && ( */}
      <div
        className={`border-t border-gray-200  ${vipData?.background?.color}`}>
        <div
          style={{
            ...marginStyles,
            ...getPaddingStyles(vipData?.padding, currentDeviceType),
            ...getBorderProps(vipData?.border, currentDeviceType),
          }}
          className={`${vipData?.border?.borderStyle?.[currentDeviceType]} px-6 py-10 sm:py-5 lg:px-8`}>
          <div className="mx-auto max-w-2xl text-center mb-6">
            {vipData?.Title?.showComponent?.[currentDeviceType] && (
              <p
                className={`flex ${vipData?.Title?.fontSize?.[currentDeviceType]} gap-0.5 justify-center items-end ${vipData?.Title?.weight?.[currentDeviceType]} rounded tracking-tight`}
                style={{
                  color: vipData?.Title?.textColor?.[currentDeviceType],
                }}>
                {vipData?.Title?.text}
                <span className="text-l relative top-[-3px]">&reg;</span>
              </p>
            )}
            {vipData?.Description?.showComponent?.[currentDeviceType] && (
              <p
                className={`mt-4 ${vipData?.Description?.fontSize?.[currentDeviceType]} ${vipData?.Description?.weight?.[currentDeviceType]} text-left`}
                style={{
                  color: vipData?.Description?.textColor?.[currentDeviceType],
                }}>
                {vipData?.Description?.text}
              </p>
            )}
            <div className="mt-4 text-left text-black text-editor-content">
              <div
                style={{ lineHeight: 1.5 }}
                dangerouslySetInnerHTML={{ __html: vipData?.content }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};
